var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.liabilityOwner || _vm.liabilityTypeVisible
        ? _c(
            "span",
            [
              _c("section-title", [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.applicantName) +
                    ",\n      " +
                    _vm._s(
                      _vm.$t(
                        "application-standalone.pages.liabilities.tellUsAboutThisLiability"
                      )
                    ) +
                    "\n    "
                ),
              ]),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _vm.liabilityTypeVisible
                    ? _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "page-section-group-layout",
                            [
                              _c(
                                "section-title",
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm.$t(
                                          "application-standalone.questions.liabilities.type"
                                        )
                                      ) +
                                      "\n            "
                                  ),
                                  _vm.getValidator("liabilityType.required")
                                    ? _c("input-required-indicator")
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("select-field", {
                                attrs: {
                                  value: _vm.liabilityType,
                                  placeholder: _vm.$t(
                                    "application-form.liability-type"
                                  ),
                                  options: _vm.filteredLiabilityTypeOptions,
                                  validator: _vm.getValidator("liabilityType"),
                                },
                                on: {
                                  "update:value": function ($event) {
                                    _vm.liabilityType = $event
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "page-section-group-layout",
                        [
                          _c("section-title", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "application-standalone.questions.liabilities.owner"
                                )
                              ) + "\n          "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("select-field", {
                            attrs: {
                              value: _vm.liabilityOwner,
                              placeholder: _vm.$t(
                                "application-standalone.questions.liabilities.owner"
                              ),
                              options: _vm.applicantsAsOptions,
                              "allow-empty": false,
                            },
                            on: { "update:value": _vm.handleOwnerChange },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _vm.liabilityLimitVisible
            ? _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "page-section-group-layout",
                    [
                      _c(
                        "section-title",
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "application-standalone.questions.liabilities.limit"
                              )
                            ) + "\n          "
                          ),
                          _vm.getValidator("liabilityLimit.required")
                            ? _c("input-required-indicator")
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("currency-field", {
                        attrs: {
                          value: _vm.liabilityLimit,
                          validator: _vm.getValidator("liabilityLimit"),
                        },
                        on: {
                          "update:value": function ($event) {
                            _vm.liabilityLimit = $event
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.liabilityBalanceVisible
            ? _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "page-section-group-layout",
                    [
                      _c(
                        "section-title",
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "application-standalone.questions.liabilities.balance"
                              )
                            ) + "\n          "
                          ),
                          _vm.getValidator("liabilityBalance.required")
                            ? _c("input-required-indicator")
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("currency-field", {
                        attrs: {
                          value: _vm.liabilityBalance,
                          validator: _vm.getValidator("liabilityBalance"),
                        },
                        on: {
                          "update:value": function ($event) {
                            _vm.liabilityBalance = $event
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "align-items-end" },
        [
          _vm.liabilityPaymentVisible
            ? _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "page-section-group-layout",
                    [
                      _c(
                        "section-title",
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "application-standalone.questions.liabilities.payment"
                              )
                            ) + "\n          "
                          ),
                          _vm.getValidator("liabilityPayment.required")
                            ? _c("input-required-indicator")
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("currency-field", {
                        attrs: {
                          value: _vm.liabilityPayment,
                          validator: _vm.getValidator("liabilityPayment"),
                        },
                        on: {
                          "update:value": function ($event) {
                            _vm.liabilityPayment = $event
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.liabilityMaturityDateVisible
            ? _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "page-section-group-layout",
                    [
                      _c(
                        "section-title",
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "application-standalone.questions.maturityDate"
                              )
                            ) + "\n          "
                          ),
                          _vm.getValidator("liabilityMaturityDate").required
                            ? _c("input-required-indicator")
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("date-field", {
                        attrs: {
                          value: _vm.liabilityMaturityDate,
                          validator: _vm.getValidator("liabilityMaturityDate"),
                        },
                        on: {
                          "update:value": function ($event) {
                            _vm.liabilityMaturityDate = $event
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.liabilityPayoffVisible
            ? _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "page-section-group-layout",
                    [
                      _c(
                        "section-title",
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("application-standalone.questions.payoff")
                            ) + "\n          "
                          ),
                          _vm.getValidator("liabilityPayoff.required")
                            ? _c("input-required-indicator")
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("select-field", {
                        attrs: {
                          value: _vm.liabilityPayoff,
                          options: _vm.liabilityPayoffOptions,
                          placeholder: _vm.$t(
                            "application-standalone.questions.payoff"
                          ),
                          validator: _vm.getValidator("liabilityPayoff"),
                        },
                        on: {
                          "update:value": function ($event) {
                            _vm.liabilityPayoff = $event
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.liabilityDescriptionVisible
        ? _c(
            "page-section-group-layout",
            [
              _c(
                "section-title",
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.$t(
                          "application-standalone.questions.liabilities.description"
                        )
                      ) +
                      "\n      "
                  ),
                  _vm.getValidator("liabilityDescription.required")
                    ? _c("input-required-indicator")
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("text-field", {
                        attrs: {
                          value: _vm.liabilityDescription,
                          placeholder: _vm.$t(
                            "application-standalone.questions.liabilities.description"
                          ),
                          validator: _vm.getValidator("liabilityDescription"),
                        },
                        on: {
                          "update:value": function ($event) {
                            _vm.liabilityDescription = $event
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }